import { gql } from '@apollo/client'

export const GET_X_AUTH_URL = gql`
  query GetXAuthUrl {
    getXAuthUrl {
      authUrl
      state
      codeChallenge
    }
  }
`

export const AUTHENTICATE_WITH_X = gql`
  mutation AuthenticateWithX($input: XAuthCallbackInput!) {
    authenticateWithX(input: $input) {
      user {
        id
        xUsername
        xDisplayName
        xProfileImage
        xFollowersCount
        xFollowingCount
        xTweetCount
        xVerified
        xCreatedAt
        phoneNumber
        phoneVerified
        subscription {
          status
          tier
          currentPeriodEnd
        }
        credits
        creatorScore
        timezone
        createdAt
        lastLoginAt
      }
      token
      refreshToken
    }
  }
`

export const SEND_PHONE_VERIFICATION = gql`
  mutation SendPhoneVerification($input: PhoneVerificationInput!) {
    sendPhoneVerification(input: $input)
  }
`

export const VERIFY_PHONE = gql`
  mutation VerifyPhone($input: VerifyPhoneCodeInput!) {
    verifyPhone(input: $input) {
      id
      phoneVerified
      phoneNumber
    }
  }
`

export const GET_ME = gql`
  query Me {
    me {
      id
      xUsername
      xDisplayName
      xProfileImage
      xFollowersCount
      xFollowingCount
      xTweetCount
      xVerified
      xCreatedAt
      phoneNumber
      phoneVerified
      subscription {
        status
        tier
        currentPeriodEnd
      }
      credits
      creatorScore
      timezone
      isGuest
      guestMessagesLeft
      guestDemoComplete
      createdAt
      lastLoginAt
    }
  }
`

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refreshToken: String) {
    refreshToken(refreshToken: $refreshToken) {
      user {
        id
        xUsername
        xDisplayName
        xProfileImage
        xFollowersCount
        xFollowingCount
        xTweetCount
        xVerified
        xCreatedAt
        phoneNumber
        phoneVerified
        subscription {
          status
          tier
          currentPeriodEnd
        }
        credits
        creatorScore
        timezone
        createdAt
        lastLoginAt
      }
      token
      refreshToken
    }
  }
`

export const REFRESH_X_TOKEN = gql`
  mutation RefreshXToken {
    refreshXToken
  }
`

export const UPDATE_USER_TIMEZONE = gql`
  mutation UpdateUserTimezone($timezone: String!) {
    updateUserTimezone(timezone: $timezone) {
      id
      timezone
    }
  }
`

export const LOGOUT = gql`
  mutation Logout {
    logout
  }
`